interface Props {
  props: {
    label?: string;
    value?: string | number;
    delta?: string;
    deltaDirection?: 'up' | 'down' | 'flat';
  };
}

const DELTA_COLOR: Record<'up' | 'down' | 'flat', string> = {
  up: '#2f855a',
  down: '#c0392b',
  flat: 'var(--text-soft)',
};

export function PanelKPICard({ props }: Props) {
  const { label, value, delta, deltaDirection } = props ?? {};
  return (
    <div
      style={{
        background: 'var(--surface)',
        border: '1px solid var(--border)',
        borderRadius: 8,
        padding: '10px 12px',
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
        minWidth: 0,
      }}
    >
      {label && (
        <div
          style={{
            fontSize: 10,
            color: 'var(--text-soft)',
            textTransform: 'uppercase',
            letterSpacing: 0.4,
            fontWeight: 600,
          }}
        >
          {label}
        </div>
      )}
      <div
        style={{
          fontSize: 20,
          fontWeight: 600,
          color: 'var(--text)',
          fontVariantNumeric: 'tabular-nums',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {value ?? '—'}
      </div>
      {delta && (
        <div
          style={{
            fontSize: 11,
            color: DELTA_COLOR[deltaDirection ?? 'flat'],
            fontWeight: 500,
          }}
        >
          {delta}
        </div>
      )}
    </div>
  );
}
